export default  {"src":"/_next/static/image/public/images/icon_sm_dados_bancarios_dark.af1fa0cf99168cf5286ce3a7e7e3ef4d.svg","height":17,"width":25};